let Test = require('@/mixins/Forms/2022/NRCA_LTI_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection`,
                    code_reference: `NA7.6.2.1`,
                    questions: {
                        question_1: {
                            id: `1`,
                            question: `The occupant sensing lighting controls are shown on plan documents and are installed.`,
                            code_reference: `NA7.6.2.1(a)`,
                            answer: false
                        },
                        question_2: {
                            id: `2`,
                            question: `Occupant sensing lighting control is installed per manufacturer’s instructions to minimize false triggering – such as to install an occupancy sensor away from HVAC diffusers to avoid probable false triggering.`,
                            code_reference: `NA7.6.2.1(c)`,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: `Functional Testing`,
                    code_reference: `NA7.6.2.5`,
                    steps: {
                        step_1: {
                            id: `1`,
                            name: `<b>Occupied Control Zone Test</b>. Simulate an occupied condition in the control zone controlled by the occupant sensor.`,
                            code_reference: `NA7.6.2.4(a)`,
                            questions: {
                                question_1: {
                                    id: `1.1`,
                                    type: 'Boolean',
                                    question: `Immediately upon occupancy of the control zone, the occupant sensors turn on controlled lighting.`,
                                    code_reference: `NA7.6.2.4(a)1`,
                                    answer: false,
                                    display:true
                                },
                                question_2: {
                                    id: `1.2`,
                                    type: 'Float',
                                    question: `Enter the illuminance value in footcandles (fc) measured at a location in the control zone where the controlled lighting is at full light output or designed light output if it has been documented that dimming luminaires have been intentionally tuned to less than full output and the design illuminance levels are provided.(Informational note: Automatic daylighting controls may need to be temporarily overridden to achieve full or designed light output for the test.)`,
                                    code_reference: `NA7.6.2.4(a)2`,
                                    answer: '',
                                    display:true
                                },
                                question_3: {
                                    id: `1.3`,
                                    type: 'Boolean',
                                    question: `Signal sensitivity is adequate to achieve desired control.`,
                                    code_reference: `NA7.6.2.4(a)3`,
                                    answer: false,
                                    display:true
                                },
                                question_4: {
                                    id: `1.4`,
                                    type: 'Boolean',
                                    question: `Status indicator or annunciator operates properly.`,
                                    code_reference: `NA7.6.2.4(a)4, Section 110.9(b)4C`,
                                    answer: false,
                                    display:true
                                },
                            }
                        },
                        step_2: {
                            id: `2`,
                            name: `Simulate an unoccupied condition in the control zone controlled by the occupant sensor. Confirm that at least one other control zone within the office space is occupied.`,
                            code_reference: `NA7.6.2.4(b)`,
                            questions: {
                                question_1: {
                                    id: `2.1`,
                                    type: 'Boolean',
                                    question: `The occupant sensor uniformly reduces light output of the controlled lighting in 20 minutes or less from the start of the unoccupied condition in the control zone.`,
                                    code_reference: `NA7.6.2.4(b)1, Section 130.1(c)6Dii, Section 160.5(b)4CvibII`,
                                    answer: false,
                                    display:true
                                },
                                question_2: {
                                    id: `2.2`,
                                    type: 'Float',
                                    question: `Enter the illuminance value during unoccupancy in footcandles (fc) measured at the same location as in Step 1.2.`,
                                    code_reference: null,
                                    answer: '',
                                    display:true
                                },
                                question_3: {
                                    id: `2.3`,
                                    type: 'Percentage',
                                    question: `Calculate the ratio of the illuminance during unoccupancy to the illuminance at full or designed light output in %. [Step 2.2 / Step 1.2] x 100`,
                                    code_reference: null,
                                    answer: '',
                                    display:true

                                }, question_4: {
                                    id: `2.4`,
                                    type: 'BooleanResult',
                                    question: `The ratio of illuminance from Step 2.3 is no more than 20%`,
                                    code_reference: `NA7.6.2.4(b)2, Section 130.1(c)6Dii, Section 160.5(b)4CvibII`,
                                    answer: false,
                                    display:true
                                },
                                question_5: {
                                    id: `2.5`,
                                    type: `Boolean`,
                                    question: `The occupant sensing control does not trigger a false on from movement outside of the control zone or from HVAC operation. <br> Informational note: The field of view of occupant sensors in the adjacent control zones in office spaces larger than 250 square feet may overlap, but the field of view should stay away from an adjacent enclosed space that is not part of the office space, like conference rooms, and private offices.)`,
                                    code_reference: `NA7.6.2.4(b)3`,
                                    answer: false,
                                    display:true
                                },
                                question_6: {
                                    id: `2.6`,
                                    type: `Boolean`,
                                    question: `Signal sensitivity is adequate to achieve desired control.`,
                                    code_reference: null,
                                    answer: false,
                                    display:true
                                }
                            }
                        },
                        step_3: {
                            id: `3`,
                            name: `<b>Control Zone Size Test</b>. Follow the procedures described in either Method 1 (Steps 3.1 – 3.1.3) or Method 2. (Steps 3.2 – 3.2.4)`,
                            code_reference: `NA7.6.2.4(c)`,
                             questions: {
                                question_0: {
                                    id: ``,
                                    type: 'Option',
                                    question: `Select Method`,
                                    options: [
                                        'Method 1',
                                        'Method 2',
                                    ],
                                    code_reference: ``,
                                    answer: '',
                                    display:true
                                },
                            }
                        },
                        step_3_1: {
                            id: `3.1`,
                            name: `<b>Method 1:</b> Simulate an unoccupied condition in the control zone controlled by the occupant sensor while standing in an adjacent control zone. Determine the “edge” of the control zone controlled by the occupant sensor by moving toward the occupant sensor until the lights controlled by the occupant sensor turn on to simulate an occupied condition for that control zone. <br> Informational note: While moving toward the occupant sensor, making additional movements, motions, or sounds may be necessary to trigger the occupant sensor.`,
                            questions: {
                                question_1: {
                                    id: `3.1.1`,
                                    type: 'Float',
                                    question: `Enter the distance in feet (ft) measured from the “edge” of the control zone to the spot that is directly below the occupant sensor. This is the radius of the control zone.`,
                                    code_reference: `NA7.6.2.4(c), Method 1`,
                                    answer: '',
                                    display:false
                                },
                                question_2: {
                                    id: `3.1.2`,
                                    type: 'Float',
                                    question: `Calculate the area (in ft2) of the control zone by using the formula: Area = 3.14 * radius2.`,
                                    code_reference: `NA7.6.2.4(c), Method 1`,
                                    answer: '',
                                    display:false
                                },
                                question_3: {
                                    id: `3.1.3`,
                                    type: 'BooleanResult',
                                    question: `The area of the control zone (Step 3.1.2) is less than or equal to 600 square feet.`,
                                    code_reference: null,
                                    answer: false,
                                    display:false
                                }
                            },
                        },
                        step_3_2: {
                            id: `3.2`,
                            name: `<b>Method 2:</b> Simulate an unoccupied condition for the entire office space.`,
                            code_reference: `NA7.6.2.4(c), Method 2`,
                            questions: {
                                question_1: {
                                    id: `3.2.1`,
                                    type: 'Float',
                                    question: `Walk through the space and count the number of zones of lighting that turn on automatically. Enter the number of zones that turn on automatically.`,
                                    code_reference: `NA7.6.2.4(c), Method 2`,
                                    answer: '',
                                    display:false
                                },
                                question_2: {
                                    id: `3.2.2`,
                                    type: 'Float',
                                    question: `Enter the area of the office space (in ft<sup>2</sup>) from construction plans or from other information source such as construction documents or Nonresidential Certificates of Compliance (NRCCs).`,
                                    code_reference: `NA7.6.2.4(c)2, Method 2`,
                                    answer: '',
                                    display:false
                                },
                                question_3: {
                                    id: `3.2.3`,
                                    type: 'Float',
                                    question: `Divide the area of the office by the number of zones. Enter the value in square feet. This calculated value is the assessed control zone size.`,
                                    code_reference: `NA7.6.2.4(c)3, Method 2`,
                                    answer: '',
                                    display:false
                                },
                                question_4: {
                                    id: `3.2.4`,
                                    type: 'BooleanResult',
                                    question: `The area of the control zone is less than or equal to 600 square feet.`,
                                    code_reference: `NA7.6.2.4(c)4, Method 2, Section 130.1(c)6Di, Section 160.5(b)4CvibIII`,
                                    answer: '',
                                    display:false
                                }
                            },
                        },
                        step_4: {
                            id: `4`,
                            name: `<b>Unoccupied Office Test</b>. Simulate an unoccupied condition in all control zones controlled by all occupant sensors in the office.`,
                            code_reference: null,
                            questions: {
                                question_1: {
                                    id: `4.1`,
                                    type: `Boolean`,
                                    question: `In 20 minutes or less from the start of the unoccupied condition of the entire office, all controlled lighting in the office is turned off.`,
                                    code_reference: `NA7.6.2.4(d), Section 130.1(c)6Diii, Section 160.5(b)4CvibIII`,
                                    answer: false,
                                    display:true
                                },
                            },
                        }
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },

    methods: {

        functionalTestEvaluation() {

            if (!this.testIsReady) return;



            var steps = this.form.functional_test.steps;
            var s1Questions = steps.step_1.questions;
            var s2Questions = steps.step_2.questions;

            // Line I =  [(Line H / Line D])
            var row_D = s1Questions.question_2.answer;
            var row_H = s2Questions.question_2.answer;
            var row_I = ((row_H / row_D));
            s2Questions.question_3.answer = this.isValidNumber(row_I) ? row_I : 0;
            s2Questions.question_4.answer = (row_I >= 0 && row_I <= .2) ? true : false;
            //
            var s3_1Questions = steps.step_3_1.questions;
            var s3_2Questions = steps.step_3_2.questions;

            if (steps.step_3.questions.question_0.answer == 'Method 1') {
                _.each(s3_2Questions, item => item.display = false)

                _.each(s3_1Questions, item=> item.display = true)

                var row_M = s3_1Questions.question_1.answer;
                s3_1Questions.question_2.answer = 3.14 * (row_M ** 2);
                var row_N = s3_1Questions.question_2.answer;

                var row_O = s3_1Questions.question_3.answer = (row_N > 0 && row_N <= 600) ? true : false;

                if (row_O == false) {
                    this.form.functional_test.result = false;
                    console.log('o')
                }
            }

            else if (steps.step_3.questions.question_0.answer == 'Method 2') {
                _.each(s3_1Questions,(item)=>{
                    item.display = false;
                })
                _.each(s3_2Questions,(item)=>{
                    item.display = true;
                })

                var row_P = s3_2Questions.question_1.answer;
                var row_Q = s3_2Questions.question_2.answer;
                var row_R = (row_Q / row_P);
                s3_2Questions.question_3.answer = this.isValidNumber(row_R) ? row_R : 0;


                var row_S = s3_2Questions.question_4.answer = (row_R > 0 && row_R <= 600) ? true : false;


                if (row_S == false ) {
                    this.form.functional_test.result = false;
                    console.log('s')

                }
            }

            // Line O = 3.14 * (Line M)^2

            // var row_M = s3_1Questions.question_1.answer;
            // s3_1Questions.question_2.answer = 3.14 * (row_M ** 2);
            // var row_N = s3_1Questions.question_2.answer;

            // var row_O = s3_1Questions.question_3.answer = (row_N > 0 && row_N <= 600) ? true : false;

            // Line R = Line Q/ Line P


            // var row_P = s3_2Questions.question_1.answer;
            // var row_Q = s3_2Questions.question_2.answer;
            // var row_R = (row_Q / row_P);
            // s3_2Questions.question_3.answer = this.isValidNumber(row_R) ? row_R : 0;


            // var row_S = s3_2Questions.question_4.answer = (row_R > 0 && row_R <= 600) ? true : false;


            // if (row_S == false || row_O == false) {
            //     this.form.functional_test.result = false;
            // }
        },

    },
}


